import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
var InteractionManager = /*#__PURE__*/ function() {
    "use strict";
    function InteractionManager() {
        _class_call_check(this, InteractionManager);
        _define_property(this, "waitForRelations", new Map());
        _define_property(this, "simultaneousRelations", new Map());
    }
    _create_class(InteractionManager, [
        {
            key: "configureInteractions",
            value: function configureInteractions(handler, config) {
                this.dropRelationsForHandlerWithTag(handler.getTag());
                if (config.waitFor) {
                    var waitFor = [];
                    config.waitFor.forEach(function(otherHandler) {
                        // New API reference
                        if (typeof otherHandler === "number") {
                            waitFor.push(otherHandler);
                        } else {
                            // Old API reference
                            waitFor.push(otherHandler.handlerTag);
                        }
                    });
                    this.waitForRelations.set(handler.getTag(), waitFor);
                }
                if (config.simultaneousHandlers) {
                    var simultaneousHandlers = [];
                    config.simultaneousHandlers.forEach(function(otherHandler) {
                        if (typeof otherHandler === "number") {
                            simultaneousHandlers.push(otherHandler);
                        } else {
                            simultaneousHandlers.push(otherHandler.handlerTag);
                        }
                    });
                    this.simultaneousRelations.set(handler.getTag(), simultaneousHandlers);
                }
            }
        },
        {
            key: "shouldWaitForHandlerFailure",
            value: function shouldWaitForHandlerFailure(handler, otherHandler) {
                var waitFor = this.waitForRelations.get(handler.getTag());
                if (!waitFor) {
                    return false;
                }
                var shouldWait = false;
                waitFor.forEach(function(tag) {
                    if (tag === otherHandler.getTag()) {
                        shouldWait = true;
                        return; //Returns from callback
                    }
                });
                return shouldWait;
            }
        },
        {
            key: "shouldRecognizeSimultaneously",
            value: function shouldRecognizeSimultaneously(handler, otherHandler) {
                var simultaneousHandlers = this.simultaneousRelations.get(handler.getTag());
                if (!simultaneousHandlers) {
                    return false;
                }
                var shouldRecognizeSimultaneously = false;
                simultaneousHandlers.forEach(function(tag) {
                    if (tag === otherHandler.getTag()) {
                        shouldRecognizeSimultaneously = true;
                        return;
                    }
                });
                return shouldRecognizeSimultaneously;
            }
        },
        {
            key: "shouldRequireHandlerToWaitForFailure",
            value: function shouldRequireHandlerToWaitForFailure(_handler, _otherHandler) {
                //TODO: Implement logic
                return false;
            }
        },
        {
            key: "shouldHandlerBeCancelledBy",
            value: function shouldHandlerBeCancelledBy(_handler, _otherHandler) {
                //TODO: Implement logic
                return false;
            }
        },
        {
            key: "dropRelationsForHandlerWithTag",
            value: function dropRelationsForHandlerWithTag(handlerTag) {
                this.waitForRelations.delete(handlerTag);
                this.simultaneousRelations.delete(handlerTag);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.waitForRelations.clear();
                this.simultaneousRelations.clear();
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (!this.instance) {
                    this.instance = new InteractionManager();
                }
                return this.instance;
            }
        }
    ]);
    return InteractionManager;
}();
_define_property(InteractionManager, "instance", void 0);
export { InteractionManager as default };
